import { useLang } from '../../../../../../../language';
import React, { useCallback, useEffect, useState, Children } from 'react';

import { Calendar, momentLocalizer } from 'react-big-calendar'

import moment from 'moment'

import "react-big-calendar/lib/css/react-big-calendar.css";
import { isStatusSucess } from '../../../../../../../helpers/helpers';
import { AlquileresServices } from '../../../Alquileres/services/alquileres.service';
import { cloneDeep } from 'lodash';
import { Spinner } from 'react-bootstrap';

const localizer = momentLocalizer(moment)
require('moment/locale/ca.js')

export const VerCalendario = ({ idaparato }: any) => {

    const Lang = useLang()

    const [events, setEvents] = useState<any>([])


    const [startEndDates, setStartEndDates] = useState<any>({});

    const [objFechasData, setObjFechasData] = useState<any>({});

    const [startEndSlot, setStartEndSlot] = useState<any>({
        start: '',
        end: '',
    });

    const lang = {
        ca: {
            week: 'Setmana',
            work_week: 'Setmana de treball',
            day: 'Dia',
            month: 'Mes',
            previous: '<',
            next: '>',
            today: 'Avui',
            agenda: 'El Diari',

            showMore: (total: any) => `+${total} més`,
        }
    }

    const getStartAndEndDate = (date: Date) => {

        const firstDay = moment(new Date(date.getFullYear(), date.getMonth(), 1)).format('YYYY-MM-DD');
        const lastDay = moment(new Date(date.getFullYear(), date.getMonth() + 1, 0)).format('YYYY-MM-DD');

        setStartEndDates({
            fechainicio: firstDay,
            fechafin: lastDay,
        })
    };

    const onNavigate = useCallback((date: Date) => {
        getStartAndEndDate(date);
    }, []);


    const [fetchCheckDisponibilidad, fetchCheckDisponibilidadData] = AlquileresServices.GET_CHECK_DISPONIBILIDAD()

    useEffect(() => {

        if (isStatusSucess(fetchCheckDisponibilidadData.status)) {

            setObjFechasData(fetchCheckDisponibilidadData.data?.data)
        }

    }, [fetchCheckDisponibilidadData]);


    useEffect(() => {

        if (startEndDates.fechainicio && startEndDates.fechafin) {

            fetchCheckDisponibilidad({
                params: {
                    fechadesde: startEndDates.fechainicio,
                    fechahasta: startEndDates.fechafin,
                    idproducto: idaparato,
                    estricto: false,
                }
            })
        }

    }, [startEndDates.fechainicio, startEndDates.fechafin]);


    const ColoredDateCellWrapper = useCallback(({ children, value }: any) => {

        let color = ''

        const diaActual = moment(new Date(value)).format('YYYY-MM-DD')

        // if (formDatosGenerales.horainicio === diaActual) {
        //     color = '#6bebb0'
        // }

        // -------- Colorear slot seleccionado

        const startEndSlotTemp = cloneDeep(startEndSlot)

        let slotStart = startEndSlotTemp.start
        let slotEnd = startEndSlotTemp.end

        if (!slotEnd) slotEnd = slotStart

        if ((new Date(value))?.getTime() >= (new Date(slotStart + 'T00:00:00'))?.getTime() &&
            (new Date(value))?.getTime() <= (new Date(slotEnd + 'T00:00:00'))?.getTime()) {
            color = '#b0efbf'
        }

        // -------- Colorear dia festivo

        if (isFeriadoySabadoODomingo(value, startEndDates, objFechasData)) {
            color = '#ffe6e6'
        }

        return React.cloneElement(Children.only(children), {
            style: {
                ...children.style,
                backgroundColor: color,
            },
        })

    }, [startEndDates, startEndSlot, objFechasData])


    const isFeriadoySabadoODomingo = (value: any, startEndDates: any, objFechasData: any) => {

        const valueDate = new Date(value)

        const valueDateFormat = moment(new Date(value)).format('YYYY-MM-DD')

        const fechainicio = new Date(startEndDates.fechainicio)
        const fechafin = new Date(startEndDates.fechafin)

        if (fechainicio?.getTime() <= valueDate.getTime() && valueDate.getTime() <= fechafin?.getTime()) {

            if (valueDate.getDay() === 6 || valueDate.getDay() === 0 || (objFechasData[valueDateFormat] && objFechasData[valueDateFormat] !== 'diadecobro')) {

                return true
            }
        }

        return false
    }

    useEffect(() => {

        getStartAndEndDate(new Date());

    }, [])

    return (
        <>

            <section className="position-relative">
                <Calendar
                    localizer={localizer}
                    events={events}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: 400 }}
                    // onSelectEvent={handleSelectEvent}
                    // onSelectSlot={handleSelectSlot}
                    culture='ca'
                    messages={lang['ca']}
                    views={
                        {
                            month: true
                        }
                    }
                    selectable
                    components={{
                        dateCellWrapper: ColoredDateCellWrapper
                    }}
                    onNavigate={onNavigate}

                />
                {
                    fetchCheckDisponibilidadData.loading &&
                    <div className="d-flex py-5 justify-content-center align-items-center OverlayCalendar__Loading">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                }
            </section>


        </>
    )
};
